import { render, staticRenderFns } from "./PagamentoAssociarEtapas.vue?vue&type=template&id=4bd1d5d2"
import script from "./PagamentoAssociarEtapas.vue?vue&type=script&lang=js"
export * from "./PagamentoAssociarEtapas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports